import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // For navigation to login
import "./planCard.css";
import { useAuth } from "../../../components/AuthProvider";

const PlanCard = ({ plan, onViewContract, onSubmit }) => {
  const [paymentOption, setPaymentOption] = useState("automatic");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handlePaymentOptionChange = (e) => {
    setPaymentOption(e.target.value);
  };

  const handleTermsChange = (e) => {
    setAcceptTerms(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isAuthenticated) {
      navigate("/login", { state: { from: { pathname: "/plans" }}});
      return;
    }

    if (!acceptTerms) {
      alert("You must accept the terms to proceed.");
      return;
    }
    onSubmit(plan, paymentOption);
  };

  // != null Checks for both null and undefined
  const hasAutomaticPrice = plan.automatic_debt_price_in_cents != null;
  const hasSinglePrice = plan.price_in_cents != null;

  return (
    <div
      style={{ width: "290px", position: "relative" }}
      className={`card themed-block text-center pt-5 pb-4 px-1 mb-5 mx-auto d-flex flex-column align-items-center ${plan.highlight ? "highlight-frame" : ""}`}
    >
      {/* Crossing band for highlighted plans */}
      {plan.highlight && (
        <div className="highlight-band">Recomendado</div>
      )}
      {/* Badge de descuento */}
      {plan.percentage_offer && (
        (paymentOption === "automatic" && plan.promo_automatic_debt_price_in_cents) ||
        (paymentOption === "single" && plan.promo_price_in_cents)
      ) && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "#ff4d4f",
            color: "white",
            padding: "5px 10px",
            borderRadius: "5px",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          -{plan.percentage_offer}%
        </div>
      )}

      <div className="mx-auto">
        <h2>Membresía</h2>
        <h3>{plan.name}</h3>
        <div style={{ height: "160px" }} className="d-flex my-3">
          <img
            alt={plan.name}
            height="100%"
            src={`/img/${plan.image}`}
            className="m-auto"
          />
        </div>
      </div>
      <form
        id={`paymentForm${plan.plan_id}`}
        onSubmit={handleSubmit}
        className="h-100 d-flex flex-column justify-content-between"
      >
        <div className="mx-auto">
          {hasAutomaticPrice && hasSinglePrice ? (
            <>
              <select
                name="paymentOptions"
                className="form-control payment-options text-center m-auto"
                style={{ width: "fit-content" }}
                value={paymentOption}
                onChange={handlePaymentOptionChange}
              >
                <option value="automatic">Débito Automático</option>
                <option value="single">Pago Único</option>
              </select>
              <div className="mt-3">
                <h2 className="price-display">
                  {plan.promo_automatic_debt_price_in_cents ||
                  plan.promo_price_in_cents ? (
                    paymentOption === "automatic" ? (
                      <>
                        {plan.promo_automatic_debt_price_in_cents ? (
                          <>
                            <span
                              className="text-muted price-original line-through"
                              style={{ fontSize: "16px" }}
                            >
                              {(plan.automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                            </span>
                            <br />
                            {/* Precio promocional */}
                            <span
                              className="text-primary price-discounted"
                              style={{ fontSize: "24px" }}
                            >
                              {(plan.promo_automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                            </span>
                          </>
                        ) : (
                          <span className="font-weight-bold">
                            {(plan.automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        {plan.promo_price_in_cents ? (
                          <>
                            <span
                              className="text-muted price-original line-through"
                              style={{ fontSize: "16px" }}
                            >
                              {(plan.price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                            </span>
                            <br />
                            {/* Precio promocional */}
                            <span
                              className="text-primary price-discounted"
                              style={{ fontSize: "24px" }}
                            >
                              {(plan.promo_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                            </span>
                          </>
                        ) : (
                          <span className="font-weight-bold">{(plan.price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}</span>
                        )}
                      </>
                    )
                  ) : (
                    <>
                      {/* Automatic And Single without promo  */}
                      <span
                        className={`text-muted price-original price-transition 
                          ${paymentOption === "automatic" ? "line-through" : ""
                        }`}
                        style={{
                          opacity: paymentOption === "automatic" ? 0.5 : 1,
                          fontSize:
                            paymentOption === "automatic" ? "16px" : "24px",
                        }}
                      >
                        {(plan.price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                      </span>
                      <br />
                      <span
                        className={`text-primary price-discounted price-transition 
                          ${paymentOption === "automatic" ? "" : "line-through"
                        }`}
                        style={{
                          opacity: paymentOption === "automatic" ? 1 : 0.5,
                          fontSize:
                            paymentOption === "automatic" ? "24px" : "16px",
                        }}
                      >
                        {(plan.automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                      </span>
                    </>
                  )}
                </h2>
              </div>
            </>
          ) : hasAutomaticPrice ? (
            <h2>
              {plan.promo_automatic_debt_price_in_cents ? (
                <>
                  <span
                    className={"text-muted price-original line-through"}
                    style={{ fontSize: "16px" }}
                  >
                    {(plan.automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                  </span>
                  <br />
                  <span className="font-weight-bold">
                    {(plan.promo_automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                  </span>
                </>
              ) : (
                <span className="font-weight-bold">{(plan.automatic_debt_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}</span>
              )}
            </h2>
          ) : (
            hasSinglePrice && (
              <h2>
                {plan.promo_price_in_cents ? (
                  <>
                    <span
                      className={"text-muted price-original line-through"}
                      style={{ fontSize: "16px" }}
                    >
                      {(plan.price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}
                    </span>
                    <br />
                    <span className="font-weight-bold">{(plan.promo_price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}</span>
                  </>
                ) : (
                    <span className="font-weight-bold">{(plan.price_in_cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 })}</span>
                )}
              </h2>
            )
          )}
        </div>
        {plan.all_unlimited ? (
          <p>Sesiones ilimitadas</p>
        ) : (
          <p>{plan.number_of_shared_classes} sesiones</p>
        )}
        {plan.benefits && (
          <table className="table m-0">
            <tbody>
              {plan.benefits.map((benefit, index) => (
                <tr key={index} className={index === 0 ? "border-top" : ""}>
                  <td
                    className="border-top-0 text-left pr-0 align-middle"
                    style={{ width: "90%" }}
                  >
                    {benefit.benefit}
                  </td>
                  <td className="border-top-0 text-right align-middle pl-0">
                    <i className="fas fa-check"></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <table className="table m-0">
          <tbody>
            <tr className="border-top">
              <td className="border-top-0 text-left align-middle">Duración</td>
              <td
                className="border-top-0 text-right align-middle"
                style={{ width: "90%" }}
              >
                {plan.duration} {plan.duration_type}
              </td>
            </tr>
          </tbody>
        </table>
        {isAuthenticated && (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="aceptacion"
              id={`aceptacion_${plan.plan_id}`}
              checked={acceptTerms}
              onChange={handleTermsChange}
              required
            />
            <label
              className="form-check-label terms-label"
              htmlFor={`aceptacion_${plan.plan_id}`}
            >
              <small>
                Acepto el{" "}
                <button
                  type="button"
                  className="view-contract link-button"
                  onClick={() => onViewContract(plan, paymentOption)}
                >
                  <b>
                    <u>Contrato de Servicio</u>
                  </b>
                </button>
              </small>
            </label>
          </div>
        )}
        <div className="mt-5">
          <button
            type="submit"
            className="btn color-white themed-btn mt-auto position-absolute"
            style={{ left: "50%", transform: "translateX(-50%)" }}
          >
            Seleccionar
          </button>
        </div>
      </form>
    </div>
  );
};

export default PlanCard;
